import { render, staticRenderFns } from "./RenewableEnergyPolicies.vue?vue&type=template&id=f80d8a0e&scoped=true&"
import script from "./RenewableEnergyPolicies.vue?vue&type=script&lang=js&"
export * from "./RenewableEnergyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./RenewableEnergyPolicies.vue?vue&type=style&index=0&id=f80d8a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80d8a0e",
  null
  
)

export default component.exports